import { useQuery } from '@tanstack/react-query'
import { usePmWalletStore } from '@/store/pmWalletStore'

export interface SubscriptionStatus {
  exists: boolean
  isActive: boolean
  trialEndsAt: number
  paidUntil: number
}

async function fetchSubscription(address: string): Promise<SubscriptionStatus> {
  const res = await fetch(`/api/sub/${address}`)
  if (!res.ok) throw new Error(`sub ${res.status}`)
  return (await res.json()) as SubscriptionStatus
}

/**
 * Poll /api/sub/:address каждые 30 с (быстрее после successful intent при
 * useRenewSubscription). Identity = PM-proxy address — одна проверка на весь
 * жизненный цикл.
 */
export function useSubscription() {
  const pmProxyAddress = usePmWalletStore((s) => s.pmProxyAddress)
  const activeWallet = usePmWalletStore((s) => s.activeWallet)
  const address = activeWallet === 'pm' && pmProxyAddress ? pmProxyAddress.toLowerCase() : null

  const q = useQuery<SubscriptionStatus>({
    queryKey: ['subscription', address],
    queryFn: () => fetchSubscription(address!),
    enabled: Boolean(address),
    staleTime: 10_000,
    refetchInterval: 30_000,
    retry: 2,
  })

  const data = q.data
  const now = Math.floor(Date.now() / 1000)

  return {
    address,
    exists: data?.exists ?? false,
    isActive: data?.isActive ?? false,
    paidUntil: data?.paidUntil ?? 0,
    trialEndsAt: data?.trialEndsAt ?? 0,
    onTrial: (data?.trialEndsAt ?? 0) > now && (data?.paidUntil ?? 0) <= now,
    isLoading: q.isLoading,
    refetch: q.refetch,
  }
}
